/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  UserTokensVaultMock,
  UserTokensVaultMockInterface,
} from "../UserTokensVaultMock";

const _abi = [
  {
    inputs: [],
    name: "clearProcessLastCall",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
    ],
    name: "process",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "processLastCall",
    outputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

export class UserTokensVaultMock__factory {
  static readonly abi = _abi;
  static createInterface(): UserTokensVaultMockInterface {
    return new Interface(_abi) as UserTokensVaultMockInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): UserTokensVaultMock {
    return new Contract(
      address,
      _abi,
      runner
    ) as unknown as UserTokensVaultMock;
  }
}
